(() => {
  const seen = new WeakSet();
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const imageObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) { loadImage(target); imageObserver.unobserve(target); }
    });
  }, { rootMargin: '200px 0px' }) : null;
  function loadImage(img) {
    if (img.dataset.stSrcset) { img.srcset = img.dataset.stSrcset; delete img.dataset.stSrcset; }
    if (img.dataset.stSrc) { img.src = img.dataset.stSrc; delete img.dataset.stSrc; }
    img.removeAttribute('data-st-lazy');
  }
  const activate = video => {
    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    }
    let changed = false;
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      delete source.dataset.src;
      changed = true;
    });
    if (changed) video.load();
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({ target: video, isIntersecting }) => {
      video.dataset.stVisible = isIntersecting ? 'true' : 'false';
      if (isIntersecting) {
        activate(video);
        if (video.hasAttribute('data-st-animate') && !reduceMotion.matches && !document.hidden) video.play().catch(() => {});
      } else if (video.hasAttribute('data-st-animate')) video.pause();
    });
  }, { rootMargin: '100px 0px' }) : null;
  function mount(root = document) {
    root.querySelectorAll('img[data-st-lazy]').forEach(img => {
      if (seen.has(img)) return;
      seen.add(img);
      if (imageObserver) imageObserver.observe(img); else loadImage(img);
    });
    root.querySelectorAll('video.st-r5-video').forEach(video => {
      if (seen.has(video)) return;
      seen.add(video);
      video.addEventListener('pointerdown', () => activate(video), { once: true });
      video.addEventListener('keydown', () => activate(video), { once: true });
      if (observer) observer.observe(video); else activate(video);
    });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('video.st-r5-video[data-st-animate]').forEach(video => video.pause());
  });
  document.addEventListener('shopify:section:load', event => mount(event.target));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1 && node.querySelector('video.st-r5-video, img[data-st-lazy]')) mount(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
  mount();
})();
